if (!customElements.get('stores-pills')) {
  class StoresPills extends HTMLElement {
    connectedCallback() {
      this.pills = [...this.querySelectorAll('[data-stores-pill]')];
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const pill = event.target.closest('[data-stores-pill]');
      if (!pill || !this.contains(pill)) return;

      this.setActive(pill);
      const city = pill.dataset.city;
      const section = this.closest('.section-stores');
      if (!section) return;

      const storeCards = [...section.querySelectorAll('[data-store-city]')];

      storeCards.forEach((card) => {
        const slide = card.closest('.splide__slide');
        const shouldHide = Boolean(city) && card.dataset.storeCity !== city;
        (slide || card).classList.toggle('stores-filter-hidden', shouldHide);
      });

      section.querySelectorAll('.stores-group').forEach((group) => {
        const hasVisibleStore = [...group.querySelectorAll('[data-store-city]')].some(
          (card) => !(card.closest('.splide__slide') || card).classList.contains('stores-filter-hidden'),
        );
        group.classList.toggle('stores-filter-hidden', !hasVisibleStore);
      });
    }

    setActive(activePill) {
      this.pills.forEach((pill) => {
        const isActive = pill === activePill;
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }
  }

  customElements.define('stores-pills', StoresPills);
}
